import * as React from "react";
import * as style from "./Faq.style";

const Faq: React.FC = () => {
  return (
    <div className={style.component}>
      <h1 className={style.title}>Frequently Asked Questions</h1>
      <div className={style.content}>
        <div className={style.section}>
          <div className={style.question}>Is Alcohol included?</div>
          <div className={style.answer}>
            No! Every cruise is BYOB. Bring your own booze.
          </div>
          <div className={style.question}>What to Bring?</div>
          <div className={style.answer}>
            Each boat has a large cooler and ice on board for your drinks. Plan
            to bring sunscreen, towels, and clothing that you don't care about
            getting wet.
          </div>
          <div className={style.question}>Which boat should I pick?</div>
          <div className={style.answer}>
            <p style={{ fontWeight: 600, marginBottom: 15 }}>
              Which boat is right for you?
            </p>
            <table className={style.comparisonTable}>
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Octolounge</th>
                  <th>The Kraken</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Speed &amp; getting there fast</td>
                  <td>✅ Fastest on the bay</td>
                  <td>Slower, more relaxed</td>
                </tr>
                <tr>
                  <td>Sandbar options</td>
                  <td>✅ Most flexible in shallow waters</td>
                  <td>Limited by slide/depth</td>
                </tr>
                <tr>
                  <td>Family-friendly fun</td>
                  <td>✅ Good</td>
                  <td>✅ Great — slide and extra space</td>
                </tr>
                <tr>
                  <td>Canal &amp; sightseeing cruises</td>
                  <td>✅ Yes</td>
                  <td>✅ Yes</td>
                </tr>
                <tr>
                  <td>Inflatables</td>
                  <td>✅ Yes</td>
                  <td>✅ Yes</td>
                </tr>
                <tr>
                  <td>Perfect for</td>
                  <td>Couples &amp; groups wanting variety</td>
                  <td>Families &amp; groups wanting fun + slide</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={style.question}>Do you provide captains?</div>
          <div className={style.answer}>
            <p>
              No. We offer bareboat charters, which means the vessel is
              chartered to you. If you choose not to operate the boat yourself
              (and are not qualified to do so), you may hire a captain.
            </p>
            <p>
              For your convenience, we provide a list of independent, licensed
              captains who meet our insurance and experience requirements. You
              are free to choose any qualified captain from this list, or you
              may submit your own captain for approval, provided they meet our
              safety and insurance requirements.
            </p>
          </div>
          <div className={style.question}>
            Do you have other recommendations at the Beach?
          </div>
          <div className={style.answer}>
            <p>
              Yes we do! As locals we can help you plan the perfect week or
              weekend at the beach! One of the best recommendations we have is
              to contact Dewey Beach Picnics for a beautiful evening on the
              beach with bonfires and charcuterie!
            </p>
            <p>
              Give us a call at <a href="tel:443-299-9964">443-299-9964</a> to
              learn about all the options!
            </p>
            <p>
              We also work very closely with the best Travel Agent at the beach
              Brooke Wahlgren! Give her a call at{" "}
              <a href="tel:302-299-6569">302-299-6569</a> and she can help you
              organize the perfect weekend!
            </p>
          </div>
          <div className={style.question}>Is Water Provided?</div>
          <div className={style.answer}>
            Yes each boat comes with a complimentary cooler with water bottles.
          </div>
          <div className={style.question}>Is there a bathroom?</div>
          <div className={style.answer}>
            No, the boats do not have a bathroom on board. Our Captains plan the
            trip around bathroom stops so don't worry! For Example: On our
            Sunset Cruise we have a public bathroom stop about halfway! For our
            trips that get in the water; no need for a bathroom explanation
            there!
          </div>
          <div className={style.question}>Where do we Park?</div>
          <div className={style.answer}>
            Rehoboth Bay Marina 109 Collins Ave Dewey Beach DE. Pay to park is
            located along the street as you pull in on both sides. We do offer
            Rehoboth Pick up and drop offs by request only.
          </div>

          <div className={style.question}>Where are the boats located?</div>
          <div className={style.answer}>
            At the Rehoboth Bay Marina on the south end of Dewey Beach! Both
            boats will be waiting for you there to start your trip.{" "}
            <a
              href="https://www.google.com/maps/place/Rehoboth+Bay+Marina/@38.6880719,-75.0775925,17z/data=!3m1!4b1!4m5!3m4!1s0x89b8b61c8e2c49bb:0x44cd4876d26f5427!8m2!3d38.6880677!4d-75.0754038"
              target="_blank"
            >
              Click here for the Google Maps location.
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

Faq.displayName = "Faq";
export { Faq };
